import { createAction, props } from '@ngrx/store';

export const getAllHarness = createAction('[Harness] Get all Harness');

export const getAllHarnessSuccess = createAction(
  '[Harness] Get all Harness Success',
  props<{ data: any }>(),
);

export const searchHarness = createAction(
  '[Harness] Search Harness',
  props<{
    search: string;
    assigned?: boolean;
    device?: number;
    vehicleId?: number;
  }>(),
);

export const searchHarnessSuccess = createAction(
  '[Harness] Search Harness Success',
  props<{ data: any }>(),
);

export const searchHarnessFailure = createAction(
  '[Harness] Search Harness Failure',
  props<{ error: any }>(),
);
